<script setup></script>
<template>
  <div :class="$style.card">
    <slot />
  </div>
</template>
<style module>
.card {
  padding: 0;
}
</style>
